<template>
  <div
    v-if="gtUserHasJbPrimeSubscription"
    class="JbPrimeServiceAttendantContainer"
  >
    <JbPrimeServiceAttendantButton
      :subscribed="gtUserHasJbPrimeSubscription"
      @click="handleClick"
    />
    <JbPrimeServiceAttendantDialogContainer
      v-if="displayJbPrimeServiceAttendantDialog"
      :display="displayJbPrimeServiceAttendantDialog"
      @close="displayJbPrimeServiceAttendantDialog = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import JbPrimeServiceAttendantButton from '@/components/jb-prime/JbPrimeServiceAttendantButton.vue'
import { defineAsyncComponent } from 'vue'
const JbPrimeServiceAttendantDialogContainer = defineAsyncComponent(
  () =>
    import('@/containers/jb-prime/JbPrimeServiceAttendantDialogContainer.vue'),
)
export default {
  name: 'JbPrimeServiceAttendantContainer',
  components: {
    JbPrimeServiceAttendantDialogContainer,
    JbPrimeServiceAttendantButton,
  },
  data() {
    return {
      displayJbPrimeServiceAttendantDialog: false,
    }
  },
  computed: {
    ...mapGetters({
      gtUserHasJbPrimeSubscription:
        'user/subscriptions/gtUserHasJbPrimeSubscription',
    }),
  },
  methods: {
    ...mapActions({
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
      actInsertIntent: 'user/intent/actInsertIntent',
      actEmitInfobipPageview: 'services/events/actEmitInfobipPageview',
      actEmitInfobipButtonClickEvent:
        'services/events/actEmitInfobipButtonClickEvent',
    }),
    handleClick() {
      this.displayJbPrimeServiceAttendantDialog = true
    },
  },
}
</script>

<style lang="scss"></style>
